import { REFUND_FORM_FIELDS, REFUND_FORM_FIELDS_NAMES } from './refund-form';
import { InputType } from '../../components/form/form-input-constants';

export const RefundInputs = (): any[] => [
	{
		key: REFUND_FORM_FIELDS.DISPUTE_ID,
		fieldName: REFUND_FORM_FIELDS.DISPUTE_ID,
		label: REFUND_FORM_FIELDS_NAMES.DISPUTE_ID,
		inputType: InputType.Text,
		readOnly: true,
	},
	{
		key: REFUND_FORM_FIELDS.ORDER_ID,
		fieldName: REFUND_FORM_FIELDS.ORDER_ID,
		label: REFUND_FORM_FIELDS_NAMES.ORDER_ID,
		inputType: InputType.Text,
		readOnly: true,
	},
	{
		key: REFUND_FORM_FIELDS.TRANSACTION_ID,
		fieldName: REFUND_FORM_FIELDS.TRANSACTION_ID,
		label: REFUND_FORM_FIELDS_NAMES.TRANSACTION_ID,
		inputType: InputType.Text,
		readOnly: true,
	},
	{
		key: REFUND_FORM_FIELDS.CASE_NUMBER,
		fieldName: REFUND_FORM_FIELDS.CASE_NUMBER,
		label: REFUND_FORM_FIELDS_NAMES.CASE_NUMBER,
		placeholder: REFUND_FORM_FIELDS_NAMES.CASE_NUMBER,
		inputType: InputType.Text,
	}
];
